module.exports = __webpack_public_path__ + "media/bootstrap-icons/sliders-9b59be72.svg";